import { Component, OnInit } from '@angular/core';
import { APP_CONSTANTS } from 'src/app/constants/constants';
import { CommonService } from 'src/app/services/common/common.service';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
	selector: 'app-portfolio-client-segmentation-v2',
	templateUrl: './portfolio-client-segmentation-v2.component.html',
	styleUrls: ['./portfolio-client-segmentation-v2.component.scss']
})
export class PortfolioClientSegmentationV2Component implements OnInit {
	APP_CONSTANTS = APP_CONSTANTS;

	user_details: any;
	user_role: any;

	constructor(
		private storageService: StorageService,
		public commonService: CommonService,
	) { }

	ngOnInit(): void {
		this.user_details = this.storageService.get("user_details");

		if (this.user_details.role.role == 3) {
			this.user_role = "Executive";
		} else if (this.user_details.role.role == 4) {
			this.user_role = "Advisor Manager";
		} else if (this.user_details.role.role == 5) {
			this.user_role = "Advisor";
		} else if (this.user_details.role.role == 6) {
			this.user_role = "AFA";
		} else if (this.user_details.role.role == 7) {
			this.user_role = "Assistant";
		} else if (this.user_details.role.role == 8) {
			this.user_role = "Relationship Manager";
		} else if (this.user_details.role.role == 10) {
			this.user_role = "Leadership";
		} else if (this.user_details.role.role == 11) {
			this.user_role = "Marketing Team";
		} else if (this.user_details.role.role == 12) {
			this.user_role = "Wholesaler";
		} else if (this.user_details.role.role == 13) {
			this.user_role = "Lending Officer";
		} else if (this.user_details.role.role == 14) {
			this.user_role = "Insurance Agent";
		}

		this.getClientOpportunityOverview();
	}

	client_opportunity_overview: any;
	client_opportunity_overview_loaded: boolean = false;
	getClientOpportunityOverview() {
		let route: any = ""
		if (this.user_role == "Advisor Manager") {
			route = '/advisormanagerclientsegments/';
		} else if (this.user_role == "Advisor") {
			route = '/advisorclientsegments/';
		} else if (this.user_role == "AFA") {
			route = '/advisorclientsegments/';
		}

		this.client_opportunity_overview_loaded = false;
		this.commonService.getData(route)
		.subscribe(
			(res: any) => {
				this.client_opportunity_overview = res['data'];
				this.client_opportunity_overview_loaded = true;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	selected_tab: any = "Graph";
	changeTab(value: any) {
		this.selected_tab = value;
	}

	calculateCircularProgress(percentage: any, radius: any) {
		const circumference = 2 * Math.PI * radius;
		const clamped = Math.max(0, Math.min(100, percentage));
		const strokeDashoffset = circumference - (clamped / 100) * circumference;

		return {
			strokeDasharray: circumference.toFixed(2),
			strokeDashoffset: strokeDashoffset.toFixed(2)
		};
	}

}


